import Copyright from './Copyright';

const Footer = () => {
  return (
    <footer className="w-full py-2 -mt-8">
      <div className="container mx-auto px-4 flex items-center justify-center">
        <Copyright />
        {/*<nav className="flex space-x-4 text-sm pl-2">
          <a href="/privacy">
            Privacy Policy
          </a>
  </nav>*/}
      </div>
    </footer>
  );
};

export default Footer;
